import { Avatar } from "@material-ui/core";
import React from "react";
const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.imageURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Quote",
    dataField: ["quote"],
  },
  {
    columnTitle: "Source",
    dataField: ["source"],
  },
  {
    columnTitle: "Likes",
    dataField: ["likeCount"],
  },
  {
    columnTitle: "Author",
    dataField: ["authorName"],
  },
];

export default tabConfig;
